export default {
  init() {
    // JavaScript to be fired on the testimonials page

    var catalogs = $('.catalog-form .form-wrapper').data('catalogs');

    catalogs.forEach(catalog => {
      $('.catalog-form .form-wrapper #field_pzqzv').append('<option>'+catalog.title+'</option>')
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/catalogRequest.js